/**
 * @generated SignedSource<<dc0e868b95ba870063df138533f25b91>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedUserRecommendations_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"UserRecommendationsGrid_user">;
  readonly " $fragmentType": "HpSharedUserRecommendations_user";
};
export type HpSharedUserRecommendations_user$key = {
  readonly " $data"?: HpSharedUserRecommendations_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedUserRecommendations_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": "PERSONALIZED",
      "kind": "LocalArgument",
      "name": "recommendationType"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedUserRecommendations_user",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "recommendationType",
          "variableName": "recommendationType"
        }
      ],
      "kind": "FragmentSpread",
      "name": "UserRecommendationsGrid_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "62559a73e37844932f84fb8db025ddfe";

export default node;
